// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* body {
    font-size: 22px;
    line-height: 50px;
    color: #ffffff;
    margin: 0;
    padding: 0;
    word-wrap: break-word !important;
    font-family: 'Open Sans', sans-serif;
} */

/* Nav.Link a:active{border-bottom: 5px solid #ffffff;} */


.menuactive{
  border-bottom: 5px solid #fff;
  font-weight: 700;
 }



 h3 a {
  color: #fff;
}

a {
  color: #fff;
}

h1 {
  /* margin-top: 100px; */
  font-size: 60px;
  line-height: 70px;
  font-family: "Bree Serif", "serif";
}

#container {
  margin: 0 auto;
  max-width: 890px;
}

.toggle,
[id^="drop"] {
  display: none;
}

/* Giving a background-color to the nav container. */

nav {
  margin: 0;
  padding: 0;
  background-color: #254441;
}

.top-logo {
  display: block;
  padding: 5px 0px;
  margin-top: 8px;
  float: left;
  margin-left: 60px;
}

.mobiletop-logo {
  display: block;
  padding: 0px 60px;
}

nav:after {
  content: "";
  display: table;
  clear: both;
}

/* Removing padding, margin and "list-style" from the "ul",
 * and adding "position:reltive" */

nav ul {
  padding: 0;
  margin-top: 5px;
  margin-left: 120px;
  margin-right: 20px;
  list-style: none;
  position: relative;
  float: left;
}

nav ul li ul li:hover {
  background: #000000;
}

nav ul ul li {
  width: 170px;
  float: none;
  display: list-item;
  position: relative;
}

/* Second, Third and more Tiers 
 * We move the 2nd and 3rd etc tier dropdowns to the left
 * by the amount of the width of the first tier.
*/

nav ul ul ul li {
  position: relative;
  top: -60px;
  /* has to be the same number as the "width" of "nav ul ul li" */
  left: 170px;
}

li > a:only-child:after {
  content: "";
}

/*=============== NEW CSS START HERE *===============*/

.start-new-mmenu {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  margin: 0;
  height: 80px;
  box-shadow: inherit;
  background-color: #000;
  /* background: linear-gradient(
    to right,
    #991928,
    #d52238,
    #db243a,
    #db243a,
    #db243a,
    #db243a,
    #151212
  ); */
}

.start-new-mmenumob {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  margin: 0;
  height: 48px;
  box-shadow: inherit;
  background: linear-gradient(
    to right,
    #991928,
    #d52238,
    #db243a,
    #db243a,
    #db243a,
    #242424,
    #242424
  );
}

#nav-start {
  background: transparent;
  width: 100%;
  /* width: 1370px; */
  margin: 0 auto;
}

.menu li {
  background: transparent;
  float: none;
  display: inline-block;
}

.right-menu .top-right-menu {
  float: right;
  margin: 20px 0 0;
}

.right-menu ul li {
  display: inline-block;
  margin: -10px 20px;
}

.menu li a {
  text-decoration: none;
  font-size: 15px;
  padding: 25px 10px;
  color: #ffffff;
  font-family: "Saira";
  display: inline-block;
}

.menu li.active a {
  border-bottom: 5px solid #fff;
  font-weight: 700;
}
.menu li a:hover,
.menu li a:focus {
  background: none;
  color: #fff;
  font-weight: 700;
}
#nav-start:before {
  content: "";
  position: absolute;
  right: 10px;
  bottom: 0;
  background: #242424;
  height: 100px;
  border-left: 14px solid #fff;
  box-shadow: 0 0 8px -5px #000;
  -moz-box-shadow: 0 0 8px -5px #000;
  transform: skew(-30deg);
  -webkit-transform: skew(-30deg);
  -moz-transform: skew(-30deg);
  -o-transform: skew(-30deg);
  -ms-transform: skew(-30deg);
  width: 29%;
}

#nav-start:after {
  content: "";
  display: none;
  width: 100px;
  top: 0;
  left: 0;
  background-image: url("https://digitalcrown.in/demo/eg/images/top-bg.png");
  background-repeat: no-repeat;
  margin-top: 0;
  position: absolute;
  height: 100%;
}

.start-new-mmenu:after {
  content: "";
  display: inline-block;
  width: 80%;
  height: 96px;
  left: -265px;
  background: #a7a9ac;
  clip-path: polygon(-50px 100%, 450px 730px, 100% 0, 0 100%);
  margin-top: 0;
  position: absolute;
  top: 0;
  z-index: -1;
}

.top-logo a {
  padding: 15px 0 5px;
  display: inline-block;
  margin-right: 25px;
}

.inermenu {
  display: none;
  margin-top: 33px;
  margin-right: -10px;
}

.hovermenu:hover .inermenu {
  display: inline-block;
  position: absolute;
  background: #eee;
  right: 0;
  border-radius: 5px;
  z-index: 1;
}

.hovermenu:hover .inermenu li {
  margin: 0;
}

.hovermenu:hover .inermenu li a {
  color: #333;
  font-size: 15px;
  text-decoration: none;
  display: inline-block;
  line-height: initial;
  padding: 10px 15px;
  border-bottom: 1px solid #ccc;
}

.hovermenu:hover .inermenu li a:hover {
  color: #fff;
}

.hovermenu:hover .inermenu li a .fa {
  margin-right: 5px;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #ffffff;
  min-width: 150px;
  right: 0;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  padding: 8px 10px;
  z-index: 1;
}

.dropdown-content a {
  margin: 5px;
  font-size: 14px;
  color: #000;
  text-decoration: none;
}

.dropdown-item.active, .dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #db243a;
}

.dropdown-content p {
 margin: 6px;
 padding: 0px;
}


.dropdown:hover .dropdown-content {
  display: block;
}

/* Media Queries
--------------------------------------------- */

@media all and (max-width: 1400px) {
  nav ul {
    padding: 0;
    margin-top: -2px;
    margin-left: 1px !important;
    margin-right: 0px;
    list-style: none;
    position: relative;
    float: left;
  }
  .menu li a {
    text-decoration: none;
    font-size: 12px;
    padding: 26px 20px !important;
    color: #ffffff;
    font-family: "Saira";
    display: inline-block;
  }

  .right-menu .top-right-menu {
    float: right;
    margin: 25px 20px;
  }
}

@media screen and (max-width: 2600px) {
  .right-menu .top-right-menu {
    float: right;
    margin-right: 40px;
    margin-top: 22px;
  }

  .start-new-mmenu:after {
    content: "";
    display: inline-block;
    width: 82%;
    height: 90px;
    left: -265px;
    background: #e31837;
    clip-path: polygon(-50px 100%, 450px 730px, 100% 0, 0 100%);
    margin-top: 0;
    position: absolute;
    top: 0;
    z-index: -1;
  }

  #nav-start:before {
    content: "";
    position: absolute;
    right: -5px;
    bottom: 0;
    background: #242424;
    height: 100%;
    border-left: 8px solid #fff;
    box-shadow: 0 0 8px -5px #000;
    -moz-box-shadow: 0 0 8px -5px #000;
    transform: skew(-20deg);
    -webkit-transform: skew(-20deg);
    -moz-transform: skew(-30deg);
    -o-transform: skew(-30deg);
    -ms-transform: skew(-30deg);
    width: 27%;
    top: 0;
  }

  .top-logo {
    display: block;
    padding: 0px 10px;
    margin-top: 8px;
    float: left;
    margin-left: 60px;
  }

  nav ul {
    padding: 0;
    margin-top: 4px;
    margin-left: 60px;
    margin-right: 0px;
    list-style: none;
    position: relative;
    float: left;
  }

  .menu li a {
    text-decoration: none;
    font-size: 14px;
    padding: 25px 22px;
    color: #ffffff;
    font-family: "Georama-Regular";
    display: inline-block;
  }

  .menu li.active a {
    background-color: #db233a;
    font-weight: 700;
    color: #ffffff;
    width: inherit;
    font-family: "Georama-Regular";
  }
}

@media all and (max-width: 1250px) {
  .top-logo {
    margin-left: 20px;
  }
  .top-logo .logo {
    width: 140px;
  }

  .right-menu .top-right-menu {
    float: right;
    margin: 25px 20px;
  }

  #nav-start:before {
    width: 15%;
    top: 0;
  }
}

@media all and (max-width: 1000px) {
  #logo {
    display: inline-block;
    padding: 0;
    width: 50%;
    text-align: center;
    float: none;
    margin: 0 auto 0 10px;
  }
  nav {
    margin: 0;
  }

  nav ul {
    padding: 0;
    margin-top: -2px;
    margin-left: 0px;
    margin-right: 0px;
    list-style: none;
    position: relative;
    float: left;
  }

  .toggle + a,
  .menu {
    display: none;
    position: absolute;
    z-index: 1;
    background: #ffffff;
  }

  .menu li {
    background: transparent;
    float: none;
    display: inline-block;
    border-bottom: 1px solid #eee;
  }

  .menu li a {
    padding: 12px 16px;
    color: black;
    font-weight: 600;
    /* border-bottom: 1px solid #4a4a4a; */
  }

  .menu li.active a {
    background-color: #db233a;
    font-weight: 700;
    color: #ffffff;
    width: inherit;
  }

  

  .toggle {
    display: table-caption;
    padding: 14px 8px;
    color: #fff;
    font-size: 17px;
    text-decoration: none;
    border: none;
    margin-top: -52px;
  }
  .top-logo a img {
    width: 70%;
  }
  #nav-start:before {
    content: "";
    position: absolute;
    right: 30px;
    bottom: 0;
    background: #242424;
    height: 100%;
    border-left: 8px solid #fff;
    box-shadow: 0 0 8px -5px #000;
    -moz-box-shadow: 0 0 8px -5px #000;
    transform: skew(-20deg);
    -webkit-transform: skew(-20deg);
    -moz-transform: skew(-30deg);
    -o-transform: skew(-30deg);
    -ms-transform: skew(-30deg);
    width: 27%;
    top: 0;
  }
  .right-menu ul li {
    display: inline-block;
    margin: 0;
    width: auto;
  }
  .right-menu .top-right-menu {
    float: right;
    margin: -45px 15px 0;
  }
  /* Display Dropdown when clicked on Parent Lable */
  [id^="drop"]:checked + ul {
    display: block;
    width: 92%;
    height: auto;
  }
  /* Change menu item's width to 100% */
  nav ul li {
    display: block;
    width: 100%;
  }
  nav ul ul .toggle,
  nav ul ul a {
    padding: 0 40px;
  }
  nav ul ul ul a {
    padding: 0 80px;
  }
  nav a:hover,
  nav ul ul ul a {
    background-color: #e31837;
    color: #fff;
    width: 100%;
  }

  .menuactive{background-color: #e31837 !important; color: #fff !important;  width: 100% !important;}

  nav ul li ul li .toggle,
  nav ul ul a,
  nav ul ul ul a {
    padding: 14px 20px;
    color: #fff;
    font-size: 17px;
  }
  nav ul li ul li .toggle,
  nav ul ul a {
    background-color: #212121;
  }
  /* Hide Dropdowns by Default */
  nav ul ul {
    float: none;
    position: static;
    color: #ffffff;
    /* has to be the same number as the "line-height" of "nav a" */
  }
  /* Hide menus on hover */
  nav ul ul li:hover > ul,
  nav ul li:hover > ul {
    display: none;
  }
  /* Fisrt Tier Dropdown */
  nav ul ul li {
    display: block;
    width: 100%;
  }
  nav ul ul ul li {
    position: static;
    /* has to be the same number as the "width" of "nav ul ul li" */
  }
  #nav-start {
    background: transparent;
    width: auto;
    margin: 0 auto;
  }
  .start-new-mmenu:after {
    display: none;
  }
  .top-logo {
    float: inherit;
  }
  #nav-start:after {
    display: none;
  }
  .hovermenu:hover .inermenu {
    width: 100px;
    background-color: #212121;
  }
  .hovermenu:hover .inermenu li {
    width: 100%;
  }
  .hovermenu:hover .inermenu li a {
    font-size: 15px;
    color: #fff;
    padding: 16px 15px;
    border-bottom: 1px solid #ccc;
  }
  .menu li.active a {
    border-bottom: 1px solid #fff;
    font-weight: 700;
  }

  .profile {
    width: 120px;
    padding: 15px;
  }

  .profiledata {
    /* float: right;
    margin-top: 30px; */
    margin-right: 70px;
  }

  .profilebg {
    background-color: #eee;
    background-image: linear-gradient(
      to bottom right,
      rgba(36, 36, 36, 0.08),
      rgba(250, 247, 246, 0)
    );
  }

  .logout {
    margin-top: 220px;
    box-shadow: -1px -1px 14px 0px #eee;
    color: #db233a;
  }
  .version {
    float: right;
    margin-top: 12px;
    margin-right: 18px;
    color: black;
  }
  .menubg {
    background-color: black;
  }

  .desk {
    display: block;
  }

  @media screen and (max-width: 999px) {
    .desk {
      display: none;
    }
  }

  .mob {
    display: none;
  }

  @media screen and (max-width: 999px) {
    .mob {
      display: block;
    }
    .mob-profile {
      display: inline-block;
    }
    .mob-m13 {
      padding-top: 12px;
    }
    .logo {
      width: 135px;
    }
    .mobiletop-logo {
      padding: 12px 45px;
    }
    .toggle {
      margin-top: -64px;
    }
    .right-menu .top-right-menu {
      margin: -42px 15px 0;
    }
  }

  .start-new-mmenu {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    margin: 0;
    height: 48px;
    box-shadow: inherit;
    /* background-image: linear-gradient(
          to right,
          rgba(0, 0, 0, 0.32),
          rgba(0, 0, 0, 0)
        ),
        linear-gradient(to top, #db233a, #db233a); */

    background: linear-gradient(
      to right,
      #991928,
      #991920,
      #991910,
      #db243a,
      #db233a,
      #242424,
      #242424
    );
  }
}

.hide{
  display: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/template/app/HeaderNew.css"],"names":[],"mappings":"AAAA;;;;;;;;GAQG;;AAEH,yDAAyD;;;AAGzD;EACE,6BAA6B;EAC7B,gBAAgB;CACjB;;;;CAIA;EACC,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA,oDAAoD;;AAEpD;EACE,SAAS;EACT,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;kCACkC;;AAElC;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;CAGC;;AAED;EACE,kBAAkB;EAClB,UAAU;EACV,+DAA+D;EAC/D,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,sDAAsD;;AAEtD;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,MAAM;EACN,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB;;;;;;;;;MASI;AACN;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,MAAM;EACN,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB;;;;;;;;;GASC;AACH;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,kCAAkC;EAClC,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,MAAM;EACN,OAAO;EACP,0EAA0E;EAC1E,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,mBAAmB;EAEnB,2DAA2D;EAC3D,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,QAAQ;EACR,+CAA+C;EAC/C,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;;AAGA;EACE,cAAc;AAChB;;AAEA;+CAC+C;;AAE/C;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,qBAAqB;IACrB,eAAe;IACf,6BAA6B;IAC7B,cAAc;IACd,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,mBAAmB;IAEnB,2DAA2D;IAC3D,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,WAAW;EACb;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;IAC3B,6BAA6B;IAC7B,kCAAkC;IAClC,uBAAuB;IACvB,+BAA+B;IAC/B,4BAA4B;IAC5B,0BAA0B;IAC1B,2BAA2B;IAC3B,UAAU;IACV,MAAM;EACR;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,8BAA8B;IAC9B,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,MAAM;EACR;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;IACV,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,qBAAqB;EACvB;EACA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;EACb;;EAEA;;IAEE,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,WAAW;IACX,qBAAqB;IACrB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,cAAc;EAChB;;;;EAIA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;IAC3B,6BAA6B;IAC7B,kCAAkC;IAClC,uBAAuB;IACvB,+BAA+B;IAC/B,4BAA4B;IAC5B,0BAA0B;IAC1B,2BAA2B;IAC3B,UAAU;IACV,MAAM;EACR;EACA;IACE,qBAAqB;IACrB,SAAS;IACT,WAAW;EACb;EACA;IACE,YAAY;IACZ,oBAAoB;EACtB;EACA,kDAAkD;EAClD;IACE,cAAc;IACd,UAAU;IACV,YAAY;EACd;EACA,qCAAqC;EACrC;IACE,cAAc;IACd,WAAW;EACb;EACA;;IAEE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,yBAAyB;IACzB,WAAW;IACX,WAAW;EACb;;EAEA,YAAY,oCAAoC,EAAE,sBAAsB,GAAG,sBAAsB,CAAC;;EAElG;;;IAGE,kBAAkB;IAClB,WAAW;IACX,eAAe;EACjB;EACA;;IAEE,yBAAyB;EAC3B;EACA,8BAA8B;EAC9B;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,8DAA8D;EAChE;EACA,wBAAwB;EACxB;;IAEE,aAAa;EACf;EACA,wBAAwB;EACxB;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,+DAA+D;EACjE;EACA;IACE,uBAAuB;IACvB,WAAW;IACX,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,yBAAyB;EAC3B;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,6BAA6B;EAC/B;EACA;IACE,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE;uBACmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB;;;;KAIC;EACH;;EAEA;IACE,iBAAiB;IACjB,mCAAmC;IACnC,cAAc;EAChB;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE;MACE,aAAa;IACf;EACF;;EAEA;IACE,aAAa;EACf;;EAEA;IACE;MACE,cAAc;IAChB;IACA;MACE,qBAAqB;IACvB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,YAAY;IACd;IACA;MACE,kBAAkB;IACpB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,oBAAoB;IACtB;EACF;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,MAAM;IACN,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB;;;;;oDAKgD;;IAEhD;;;;;;;;;KASC;EACH;AACF;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["/* body {\n    font-size: 22px;\n    line-height: 50px;\n    color: #ffffff;\n    margin: 0;\n    padding: 0;\n    word-wrap: break-word !important;\n    font-family: 'Open Sans', sans-serif;\n} */\n\n/* Nav.Link a:active{border-bottom: 5px solid #ffffff;} */\n\n\n.menuactive{\n  border-bottom: 5px solid #fff;\n  font-weight: 700;\n }\n\n\n\n h3 a {\n  color: #fff;\n}\n\na {\n  color: #fff;\n}\n\nh1 {\n  /* margin-top: 100px; */\n  font-size: 60px;\n  line-height: 70px;\n  font-family: \"Bree Serif\", \"serif\";\n}\n\n#container {\n  margin: 0 auto;\n  max-width: 890px;\n}\n\n.toggle,\n[id^=\"drop\"] {\n  display: none;\n}\n\n/* Giving a background-color to the nav container. */\n\nnav {\n  margin: 0;\n  padding: 0;\n  background-color: #254441;\n}\n\n.top-logo {\n  display: block;\n  padding: 5px 0px;\n  margin-top: 8px;\n  float: left;\n  margin-left: 60px;\n}\n\n.mobiletop-logo {\n  display: block;\n  padding: 0px 60px;\n}\n\nnav:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n/* Removing padding, margin and \"list-style\" from the \"ul\",\n * and adding \"position:reltive\" */\n\nnav ul {\n  padding: 0;\n  margin-top: 5px;\n  margin-left: 120px;\n  margin-right: 20px;\n  list-style: none;\n  position: relative;\n  float: left;\n}\n\nnav ul li ul li:hover {\n  background: #000000;\n}\n\nnav ul ul li {\n  width: 170px;\n  float: none;\n  display: list-item;\n  position: relative;\n}\n\n/* Second, Third and more Tiers \n * We move the 2nd and 3rd etc tier dropdowns to the left\n * by the amount of the width of the first tier.\n*/\n\nnav ul ul ul li {\n  position: relative;\n  top: -60px;\n  /* has to be the same number as the \"width\" of \"nav ul ul li\" */\n  left: 170px;\n}\n\nli > a:only-child:after {\n  content: \"\";\n}\n\n/*=============== NEW CSS START HERE *===============*/\n\n.start-new-mmenu {\n  position: absolute;\n  width: 100%;\n  left: 0;\n  top: 0;\n  margin: 0;\n  height: 80px;\n  box-shadow: inherit;\n  background-color: #000;\n  /* background: linear-gradient(\n    to right,\n    #991928,\n    #d52238,\n    #db243a,\n    #db243a,\n    #db243a,\n    #db243a,\n    #151212\n  ); */\n}\n\n.start-new-mmenumob {\n  position: absolute;\n  width: 100%;\n  left: 0;\n  top: 0;\n  margin: 0;\n  height: 48px;\n  box-shadow: inherit;\n  background: linear-gradient(\n    to right,\n    #991928,\n    #d52238,\n    #db243a,\n    #db243a,\n    #db243a,\n    #242424,\n    #242424\n  );\n}\n\n#nav-start {\n  background: transparent;\n  width: 100%;\n  /* width: 1370px; */\n  margin: 0 auto;\n}\n\n.menu li {\n  background: transparent;\n  float: none;\n  display: inline-block;\n}\n\n.right-menu .top-right-menu {\n  float: right;\n  margin: 20px 0 0;\n}\n\n.right-menu ul li {\n  display: inline-block;\n  margin: -10px 20px;\n}\n\n.menu li a {\n  text-decoration: none;\n  font-size: 15px;\n  padding: 25px 10px;\n  color: #ffffff;\n  font-family: \"Saira\";\n  display: inline-block;\n}\n\n.menu li.active a {\n  border-bottom: 5px solid #fff;\n  font-weight: 700;\n}\n.menu li a:hover,\n.menu li a:focus {\n  background: none;\n  color: #fff;\n  font-weight: 700;\n}\n#nav-start:before {\n  content: \"\";\n  position: absolute;\n  right: 10px;\n  bottom: 0;\n  background: #242424;\n  height: 100px;\n  border-left: 14px solid #fff;\n  box-shadow: 0 0 8px -5px #000;\n  -moz-box-shadow: 0 0 8px -5px #000;\n  transform: skew(-30deg);\n  -webkit-transform: skew(-30deg);\n  -moz-transform: skew(-30deg);\n  -o-transform: skew(-30deg);\n  -ms-transform: skew(-30deg);\n  width: 29%;\n}\n\n#nav-start:after {\n  content: \"\";\n  display: none;\n  width: 100px;\n  top: 0;\n  left: 0;\n  background-image: url(\"https://digitalcrown.in/demo/eg/images/top-bg.png\");\n  background-repeat: no-repeat;\n  margin-top: 0;\n  position: absolute;\n  height: 100%;\n}\n\n.start-new-mmenu:after {\n  content: \"\";\n  display: inline-block;\n  width: 80%;\n  height: 96px;\n  left: -265px;\n  background: #a7a9ac;\n  -webkit-clip-path: polygon(0 75%, 100% 0, 100% 100%, 0 100%);\n  clip-path: polygon(-50px 100%, 450px 730px, 100% 0, 0 100%);\n  margin-top: 0;\n  position: absolute;\n  top: 0;\n  z-index: -1;\n}\n\n.top-logo a {\n  padding: 15px 0 5px;\n  display: inline-block;\n  margin-right: 25px;\n}\n\n.inermenu {\n  display: none;\n  margin-top: 33px;\n  margin-right: -10px;\n}\n\n.hovermenu:hover .inermenu {\n  display: inline-block;\n  position: absolute;\n  background: #eee;\n  right: 0;\n  border-radius: 5px;\n  z-index: 1;\n}\n\n.hovermenu:hover .inermenu li {\n  margin: 0;\n}\n\n.hovermenu:hover .inermenu li a {\n  color: #333;\n  font-size: 15px;\n  text-decoration: none;\n  display: inline-block;\n  line-height: initial;\n  padding: 10px 15px;\n  border-bottom: 1px solid #ccc;\n}\n\n.hovermenu:hover .inermenu li a:hover {\n  color: #fff;\n}\n\n.hovermenu:hover .inermenu li a .fa {\n  margin-right: 5px;\n}\n\n.dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n.dropdown-content {\n  display: none;\n  position: absolute;\n  background-color: #ffffff;\n  min-width: 150px;\n  right: 0;\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n  padding: 8px 10px;\n  z-index: 1;\n}\n\n.dropdown-content a {\n  margin: 5px;\n  font-size: 14px;\n  color: #000;\n  text-decoration: none;\n}\n\n.dropdown-item.active, .dropdown-item:active {\n  color: #fff;\n  text-decoration: none;\n  background-color: #db243a;\n}\n\n.dropdown-content p {\n margin: 6px;\n padding: 0px;\n}\n\n\n.dropdown:hover .dropdown-content {\n  display: block;\n}\n\n/* Media Queries\n--------------------------------------------- */\n\n@media all and (max-width: 1400px) {\n  nav ul {\n    padding: 0;\n    margin-top: -2px;\n    margin-left: 1px !important;\n    margin-right: 0px;\n    list-style: none;\n    position: relative;\n    float: left;\n  }\n  .menu li a {\n    text-decoration: none;\n    font-size: 12px;\n    padding: 26px 20px !important;\n    color: #ffffff;\n    font-family: \"Saira\";\n    display: inline-block;\n  }\n\n  .right-menu .top-right-menu {\n    float: right;\n    margin: 25px 20px;\n  }\n}\n\n@media screen and (max-width: 2600px) {\n  .right-menu .top-right-menu {\n    float: right;\n    margin-right: 40px;\n    margin-top: 22px;\n  }\n\n  .start-new-mmenu:after {\n    content: \"\";\n    display: inline-block;\n    width: 82%;\n    height: 90px;\n    left: -265px;\n    background: #e31837;\n    -webkit-clip-path: polygon(0 75%, 100% 0, 100% 100%, 0 100%);\n    clip-path: polygon(-50px 100%, 450px 730px, 100% 0, 0 100%);\n    margin-top: 0;\n    position: absolute;\n    top: 0;\n    z-index: -1;\n  }\n\n  #nav-start:before {\n    content: \"\";\n    position: absolute;\n    right: -5px;\n    bottom: 0;\n    background: #242424;\n    height: 100%;\n    border-left: 8px solid #fff;\n    box-shadow: 0 0 8px -5px #000;\n    -moz-box-shadow: 0 0 8px -5px #000;\n    transform: skew(-20deg);\n    -webkit-transform: skew(-20deg);\n    -moz-transform: skew(-30deg);\n    -o-transform: skew(-30deg);\n    -ms-transform: skew(-30deg);\n    width: 27%;\n    top: 0;\n  }\n\n  .top-logo {\n    display: block;\n    padding: 0px 10px;\n    margin-top: 8px;\n    float: left;\n    margin-left: 60px;\n  }\n\n  nav ul {\n    padding: 0;\n    margin-top: 4px;\n    margin-left: 60px;\n    margin-right: 0px;\n    list-style: none;\n    position: relative;\n    float: left;\n  }\n\n  .menu li a {\n    text-decoration: none;\n    font-size: 14px;\n    padding: 25px 22px;\n    color: #ffffff;\n    font-family: \"Georama-Regular\";\n    display: inline-block;\n  }\n\n  .menu li.active a {\n    background-color: #db233a;\n    font-weight: 700;\n    color: #ffffff;\n    width: inherit;\n    font-family: \"Georama-Regular\";\n  }\n}\n\n@media all and (max-width: 1250px) {\n  .top-logo {\n    margin-left: 20px;\n  }\n  .top-logo .logo {\n    width: 140px;\n  }\n\n  .right-menu .top-right-menu {\n    float: right;\n    margin: 25px 20px;\n  }\n\n  #nav-start:before {\n    width: 15%;\n    top: 0;\n  }\n}\n\n@media all and (max-width: 1000px) {\n  #logo {\n    display: inline-block;\n    padding: 0;\n    width: 50%;\n    text-align: center;\n    float: none;\n    margin: 0 auto 0 10px;\n  }\n  nav {\n    margin: 0;\n  }\n\n  nav ul {\n    padding: 0;\n    margin-top: -2px;\n    margin-left: 0px;\n    margin-right: 0px;\n    list-style: none;\n    position: relative;\n    float: left;\n  }\n\n  .toggle + a,\n  .menu {\n    display: none;\n    position: absolute;\n    z-index: 1;\n    background: #ffffff;\n  }\n\n  .menu li {\n    background: transparent;\n    float: none;\n    display: inline-block;\n    border-bottom: 1px solid #eee;\n  }\n\n  .menu li a {\n    padding: 12px 16px;\n    color: black;\n    font-weight: 600;\n    /* border-bottom: 1px solid #4a4a4a; */\n  }\n\n  .menu li.active a {\n    background-color: #db233a;\n    font-weight: 700;\n    color: #ffffff;\n    width: inherit;\n  }\n\n  \n\n  .toggle {\n    display: table-caption;\n    padding: 14px 8px;\n    color: #fff;\n    font-size: 17px;\n    text-decoration: none;\n    border: none;\n    margin-top: -52px;\n  }\n  .top-logo a img {\n    width: 70%;\n  }\n  #nav-start:before {\n    content: \"\";\n    position: absolute;\n    right: 30px;\n    bottom: 0;\n    background: #242424;\n    height: 100%;\n    border-left: 8px solid #fff;\n    box-shadow: 0 0 8px -5px #000;\n    -moz-box-shadow: 0 0 8px -5px #000;\n    transform: skew(-20deg);\n    -webkit-transform: skew(-20deg);\n    -moz-transform: skew(-30deg);\n    -o-transform: skew(-30deg);\n    -ms-transform: skew(-30deg);\n    width: 27%;\n    top: 0;\n  }\n  .right-menu ul li {\n    display: inline-block;\n    margin: 0;\n    width: auto;\n  }\n  .right-menu .top-right-menu {\n    float: right;\n    margin: -45px 15px 0;\n  }\n  /* Display Dropdown when clicked on Parent Lable */\n  [id^=\"drop\"]:checked + ul {\n    display: block;\n    width: 92%;\n    height: auto;\n  }\n  /* Change menu item's width to 100% */\n  nav ul li {\n    display: block;\n    width: 100%;\n  }\n  nav ul ul .toggle,\n  nav ul ul a {\n    padding: 0 40px;\n  }\n  nav ul ul ul a {\n    padding: 0 80px;\n  }\n  nav a:hover,\n  nav ul ul ul a {\n    background-color: #e31837;\n    color: #fff;\n    width: 100%;\n  }\n\n  .menuactive{background-color: #e31837 !important; color: #fff !important;  width: 100% !important;}\n\n  nav ul li ul li .toggle,\n  nav ul ul a,\n  nav ul ul ul a {\n    padding: 14px 20px;\n    color: #fff;\n    font-size: 17px;\n  }\n  nav ul li ul li .toggle,\n  nav ul ul a {\n    background-color: #212121;\n  }\n  /* Hide Dropdowns by Default */\n  nav ul ul {\n    float: none;\n    position: static;\n    color: #ffffff;\n    /* has to be the same number as the \"line-height\" of \"nav a\" */\n  }\n  /* Hide menus on hover */\n  nav ul ul li:hover > ul,\n  nav ul li:hover > ul {\n    display: none;\n  }\n  /* Fisrt Tier Dropdown */\n  nav ul ul li {\n    display: block;\n    width: 100%;\n  }\n  nav ul ul ul li {\n    position: static;\n    /* has to be the same number as the \"width\" of \"nav ul ul li\" */\n  }\n  #nav-start {\n    background: transparent;\n    width: auto;\n    margin: 0 auto;\n  }\n  .start-new-mmenu:after {\n    display: none;\n  }\n  .top-logo {\n    float: inherit;\n  }\n  #nav-start:after {\n    display: none;\n  }\n  .hovermenu:hover .inermenu {\n    width: 100px;\n    background-color: #212121;\n  }\n  .hovermenu:hover .inermenu li {\n    width: 100%;\n  }\n  .hovermenu:hover .inermenu li a {\n    font-size: 15px;\n    color: #fff;\n    padding: 16px 15px;\n    border-bottom: 1px solid #ccc;\n  }\n  .menu li.active a {\n    border-bottom: 1px solid #fff;\n    font-weight: 700;\n  }\n\n  .profile {\n    width: 120px;\n    padding: 15px;\n  }\n\n  .profiledata {\n    /* float: right;\n    margin-top: 30px; */\n    margin-right: 70px;\n  }\n\n  .profilebg {\n    background-color: #eee;\n    background-image: linear-gradient(\n      to bottom right,\n      rgba(36, 36, 36, 0.08),\n      rgba(250, 247, 246, 0)\n    );\n  }\n\n  .logout {\n    margin-top: 220px;\n    box-shadow: -1px -1px 14px 0px #eee;\n    color: #db233a;\n  }\n  .version {\n    float: right;\n    margin-top: 12px;\n    margin-right: 18px;\n    color: black;\n  }\n  .menubg {\n    background-color: black;\n  }\n\n  .desk {\n    display: block;\n  }\n\n  @media screen and (max-width: 999px) {\n    .desk {\n      display: none;\n    }\n  }\n\n  .mob {\n    display: none;\n  }\n\n  @media screen and (max-width: 999px) {\n    .mob {\n      display: block;\n    }\n    .mob-profile {\n      display: inline-block;\n    }\n    .mob-m13 {\n      padding-top: 12px;\n    }\n    .logo {\n      width: 135px;\n    }\n    .mobiletop-logo {\n      padding: 12px 45px;\n    }\n    .toggle {\n      margin-top: -64px;\n    }\n    .right-menu .top-right-menu {\n      margin: -42px 15px 0;\n    }\n  }\n\n  .start-new-mmenu {\n    position: absolute;\n    width: 100%;\n    left: 0;\n    top: 0;\n    margin: 0;\n    height: 48px;\n    box-shadow: inherit;\n    /* background-image: linear-gradient(\n          to right,\n          rgba(0, 0, 0, 0.32),\n          rgba(0, 0, 0, 0)\n        ),\n        linear-gradient(to top, #db233a, #db233a); */\n\n    background: linear-gradient(\n      to right,\n      #991928,\n      #991920,\n      #991910,\n      #db243a,\n      #db233a,\n      #242424,\n      #242424\n    );\n  }\n}\n\n.hide{\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
